module.exports = __webpack_public_path__ + "static/media/faq2Mobile.cdfdcb57.png";